import { en } from './en.js';
import { tr } from './tr.js';
/**
 * P0 ships en + tr only (brief non-goal fence). en is ported verbatim from
 * the prototype; tr lists were ratified via Atlas native-speaker review.
 * Packs are typed const data modules (F4) — no JSON import attributes.
 */
export { en, tr };
const PACKS = new Map([
    [en.lang, en],
    [tr.lang, tr],
]);
/**
 * Neutral pack for unknown languages (F3): no word lists, no gate. Timing
 * degrades gracefully (length classes only), chunking has no stick glue.
 */
export const neutral = {
    lang: 'und',
    highFrequency: [],
    stickForward: [],
    stickBackward: [],
    highFreqGateClusters: null,
};
/** Base subtag of a BCP-47 tag ('en-US' → 'en'). */
export function baseLang(lang) {
    return (lang.split('-')[0] ?? lang).toLowerCase();
}
/**
 * F3 canonicalization: exact tag match → base-subtag match → neutral pack.
 * Only pack lookup canonicalizes — the full locale string keeps flowing to
 * the segmenter and locale-aware casing untouched.
 */
export function languagePack(lang) {
    return PACKS.get(lang) ?? PACKS.get(baseLang(lang)) ?? neutral;
}
//# sourceMappingURL=index.js.map